import page from 'page'; // eslint-disable-line import/no-extraneous-dependencies
import * as error from './pages/error';
import * as serverPersistence from './serverPersistence';
import setPageTitle from './setPageTitle';

function isFunction(object) {
    return typeof object === 'function';
}

function attachView(pageInstance, route, view) {
    if (!view || !(isFunction(view.render) && isFunction(view.tearDown))) {
        throw new Error(
            `Route ${route} view did not have render/tearDown functions`
        );
    }
    pageInstance(route, view.render);
    pageInstance.exit(route, view.tearDown);
}

function initialiseRouter() {
    page(serverPersistence.serverConfig);
    page(serverPersistence.serverLocals);
    page(serverPersistence.templateFunctions);
    page(setPageTitle);

    attachView(page, '/error', error);

    return page;
}

export default initialiseRouter;
